const resolveProjectName = (name, description) => {
    if (name && name.trim().length > 0)
        return name;
    return description;
};
const isProjectIdentifierMissing = (name, description) => !name?.trim() && !description?.trim();

export { isProjectIdentifierMissing, resolveProjectName };
